import {
	createDivs,
	repaintDivs,
	createGridDivs,
	repaintGridDivs,
	createColumnMenu,
    createHeader,
    createHeaderTable,
    createHeaderTableFixed,
    createHeaderDrag,
    createColgroup,
    createThead,
    createContent,
    createContentSumRow,
    createContentLeft,
    createContentLeftMultiSelectRow,
    createContentLeftNumColRow,
    createContentTable,
    createContentTableFixed,
    createNoRowsDiv,
    createContentRows,
    createContentRowsSumRow,
    createContentOneRow,
    createContentOneRowForIE,
    repaintRow,
    createContentOneRowTd,
    createContentOneRowTdForIE,
    repairContent
} from './gridCompCreate';

import {
	trHoverFun,
    setIntervalFun,
    editorRowChangeFun,
    afterGridDivsCreate,
    countRowHeight,
    noRowsShowFun,
    afterRepaintGrid,
    resetScrollLeft,
    hideEditMenu
} from './gridCompCreateCal';

import {
	initEventFun,
    initGridEventFun,
    initContentDivEventFun
} from './gridCompEvent';

import {
	getColumnAttr,
    getColumnByField,
    getIndexOfColumn,
    getVisibleIndexOfColumn,
    getNextVisibleInidexOfColumn,
    getSelectRows,
    getSelectRowsIndex,
    getFocusRow,
    getFocusRowIndex,
    getAllRows,
    getRowByIndex,
    getRowIndexByValue
} from './gridCompGet';

import {
	init,
    getBooleanOptions,
    initDefault,
    initGrid,
    destroySelf,
    initOptions,
    initOptionsTree,
    initVariable,
    initDataSourceVariable,
    initWidthVariable,
    initGridCompColumn,
    initGridCompColumnVar,
    initGridCompColumnFun,
    initGridCompColumnColumnMenuFun,
    initGridCompColumnHeaderLevelFun,
    initGridCompColumnLoacl,
    initGridHiddenLevelColumn,
    initGridCompFixedColumn,
    setRequired,
    initDataSource
} from './gridCompInit';

import {
	addOneRow,
    addOneRowTree,
    addOneRowTreeHasChildF,
    editClose,
    addRows,
    createContentOneRowFixed,
    updateEditRowIndex,
    deleteOneRow,
    repairSumRow,
    deleteOneRowTree,
    deleteRows,
    updateRow,
    updateValueAt,
    updateValueAtTree,
    updateValueAtEdit,
    setRowSelect,
    setRowUnselect,
    setAllRowSelect,
    setAllRowUnSelect,
    setRowFocus,
    setRowUnFocus,
    resetNumCol
} from './gridCompOperateRow';

import {
	renderTypeFun,
    renderTypeByColumn,
    renderTypeSumRow
} from './gridCompRenderType';

import {
	setColumnVisibleByColumn,
    setColumnVisibleByIndex,
    setCoulmnWidthByField,
    setColumnWidth,
    setDataSource,
    setDataSourceFun1
} from './gridCompSet';

import {
	widthChangeFun,
    widthChangeGridFun,
    widthChangeGridFunFixed,
    widthChangeGridFunOverWidthHidden,
    heightChangeFun,
    contentWidthChange
} from './gridCompWDChange';

import {
	isDblEvent,
    dblClickFun,
    clickFun,
    clickFunTree,
    clickFunEdit
} from './gridCompClick';

import{
    updateLastRowFlag,
    updateNumColLastRowFlag,
    columnsVisibleFun,
    resetThVariable,
    resetThVariableDrag,
    resetThVariableHeaderLevel,
    headerFirstClassFun,
    setRenderType,
    setShowHeader,
    setColumnPrecision,
    setMultiSelect,
    setShowNumCol,
    isGridShow,
    getBoolean
} from './gridCompOther';

import{
    formatWidth,
    swapEle,
    getString,
    getInt,
    getFloat,
    cloneObj,
    DicimalFormater,
    accAdd,
    getTrIndex
} from './ut_utility';

class gridComp{

	constructor(ele,options){
		this.init(ele,options);
		this.initGrid();
	}

};
gridComp.prototype.formatWidth = formatWidth;
gridComp.prototype.swapEle = swapEle;
gridComp.prototype.getString = getString;
gridComp.prototype.getInt = getInt;
gridComp.prototype.getFloat = getFloat;
gridComp.prototype.cloneObj = cloneObj;
gridComp.prototype.DicimalFormater = DicimalFormater;
gridComp.prototype.accAdd = accAdd;
gridComp.prototype.getTrIndex = getTrIndex;


gridComp.prototype.updateLastRowFlag = updateLastRowFlag;
gridComp.prototype.updateNumColLastRowFlag = updateNumColLastRowFlag;
gridComp.prototype.columnsVisibleFun = columnsVisibleFun;
gridComp.prototype.resetThVariable = resetThVariable;
gridComp.prototype.resetThVariableDrag = resetThVariableDrag;
gridComp.prototype.resetThVariableHeaderLevel = resetThVariableHeaderLevel;
gridComp.prototype.headerFirstClassFun = headerFirstClassFun;
gridComp.prototype.setRenderType = setRenderType;
gridComp.prototype.setShowHeader = setShowHeader;
gridComp.prototype.setColumnPrecision = setColumnPrecision;
gridComp.prototype.setMultiSelect = setMultiSelect;
gridComp.prototype.setShowNumCol = setShowNumCol;
gridComp.prototype.isGridShow = isGridShow;
gridComp.prototype.getBoolean = getBoolean;


gridComp.prototype.isDblEvent = isDblEvent;
gridComp.prototype.dblClickFun = dblClickFun;
gridComp.prototype.clickFun = clickFun;
gridComp.prototype.clickFunTree = clickFunTree;
gridComp.prototype.clickFunEdit = clickFunEdit;


gridComp.prototype.createDivs = createDivs;
gridComp.prototype.repaintDivs = repaintDivs;
gridComp.prototype.createGridDivs = createGridDivs;
gridComp.prototype.repaintGridDivs = repaintGridDivs;
gridComp.prototype.createColumnMenu = createColumnMenu;
gridComp.prototype.createHeader = createHeader;
gridComp.prototype.createHeaderTable = createHeaderTable;
gridComp.prototype.createHeaderTableFixed = createHeaderTableFixed;
gridComp.prototype.createHeaderDrag = createHeaderDrag;
gridComp.prototype.createColgroup = createColgroup;
gridComp.prototype.createThead = createThead;
gridComp.prototype.createContent = createContent;
gridComp.prototype.createContentSumRow = createContentSumRow;
gridComp.prototype.createContentLeft = createContentLeft;
gridComp.prototype.createContentLeftMultiSelectRow = createContentLeftMultiSelectRow;
gridComp.prototype.createContentLeftNumColRow = createContentLeftNumColRow;
gridComp.prototype.createContentTable = createContentTable;
gridComp.prototype.createContentTableFixed = createContentTableFixed;
gridComp.prototype.createNoRowsDiv = createNoRowsDiv;
gridComp.prototype.createContentRows = createContentRows;
gridComp.prototype.createContentRowsSumRow = createContentRowsSumRow;
gridComp.prototype.createContentOneRow = createContentOneRow;
gridComp.prototype.createContentOneRowForIE = createContentOneRowForIE;
gridComp.prototype.repaintRow = repaintRow;
gridComp.prototype.createContentOneRowTd = createContentOneRowTd;
gridComp.prototype.createContentOneRowTdForIE = createContentOneRowTdForIE;
gridComp.prototype.repairContent = repairContent;


gridComp.prototype.trHoverFun = trHoverFun;
gridComp.prototype.setIntervalFun = setIntervalFun;
gridComp.prototype.editorRowChangeFun = editorRowChangeFun;
gridComp.prototype.afterGridDivsCreate = afterGridDivsCreate;
gridComp.prototype.countRowHeight = countRowHeight;
gridComp.prototype.noRowsShowFun = noRowsShowFun;
gridComp.prototype.afterRepaintGrid = afterRepaintGrid;
gridComp.prototype.resetScrollLeft = resetScrollLeft;
gridComp.prototype.hideEditMenu = hideEditMenu;


gridComp.prototype.initEventFun = initEventFun;
gridComp.prototype.initGridEventFun = initGridEventFun;
gridComp.prototype.initContentDivEventFun = initContentDivEventFun;


gridComp.prototype.getColumnAttr = getColumnAttr;
gridComp.prototype.getColumnByField = getColumnByField;
gridComp.prototype.getIndexOfColumn = getIndexOfColumn;
gridComp.prototype.getVisibleIndexOfColumn = getVisibleIndexOfColumn;
gridComp.prototype.getNextVisibleInidexOfColumn = getNextVisibleInidexOfColumn;
gridComp.prototype.getSelectRows = getSelectRows;
gridComp.prototype.getSelectRowsIndex = getSelectRowsIndex;
gridComp.prototype.getFocusRow = getFocusRow;
gridComp.prototype.getFocusRowIndex = getFocusRowIndex;
gridComp.prototype.getAllRows = getAllRows;
gridComp.prototype.getRowByIndex = getRowByIndex;
gridComp.prototype.getRowIndexByValue = getRowIndexByValue;


gridComp.prototype.init = init;
gridComp.prototype.getBooleanOptions = getBooleanOptions;
gridComp.prototype.initDefault = initDefault;
gridComp.prototype.initGrid = initGrid;
gridComp.prototype.destroySelf = destroySelf;
gridComp.prototype.initOptions = initOptions;
gridComp.prototype.initOptionsTree = initOptionsTree;
gridComp.prototype.initVariable = initVariable;
gridComp.prototype.initDataSourceVariable = initDataSourceVariable;
gridComp.prototype.initWidthVariable = initWidthVariable;
gridComp.prototype.initGridCompColumn = initGridCompColumn;
gridComp.prototype.initGridCompColumnVar = initGridCompColumnVar;
gridComp.prototype.initGridCompColumnFun = initGridCompColumnFun;
gridComp.prototype.initGridCompColumnColumnMenuFun = initGridCompColumnColumnMenuFun;
gridComp.prototype.initGridCompColumnHeaderLevelFun = initGridCompColumnHeaderLevelFun;
gridComp.prototype.initGridCompColumnLoacl = initGridCompColumnLoacl;
gridComp.prototype.initGridHiddenLevelColumn = initGridHiddenLevelColumn;
gridComp.prototype.initGridCompFixedColumn = initGridCompFixedColumn;
gridComp.prototype.setRequired = setRequired;
gridComp.prototype.initDataSource = initDataSource;


gridComp.prototype.addOneRow = addOneRow;
gridComp.prototype.addOneRowTree = addOneRowTree;
gridComp.prototype.addOneRowTreeHasChildF = addOneRowTreeHasChildF;
gridComp.prototype.editClose = editClose;
gridComp.prototype.addRows = addRows;
gridComp.prototype.createContentOneRowFixed = createContentOneRowFixed;
gridComp.prototype.updateEditRowIndex = updateEditRowIndex;
gridComp.prototype.deleteOneRow = deleteOneRow;
gridComp.prototype.repairSumRow = repairSumRow;
gridComp.prototype.deleteOneRowTree = deleteOneRowTree;
gridComp.prototype.deleteRows = deleteRows;
gridComp.prototype.updateRow = updateRow;
gridComp.prototype.updateValueAt = updateValueAt;
gridComp.prototype.updateValueAtTree = updateValueAtTree;
gridComp.prototype.updateValueAtEdit = updateValueAtEdit;
gridComp.prototype.setRowSelect = setRowSelect;
gridComp.prototype.setRowUnselect = setRowUnselect;
gridComp.prototype.setAllRowSelect = setAllRowSelect;
gridComp.prototype.setAllRowUnSelect = setAllRowUnSelect;
gridComp.prototype.setRowFocus = setRowFocus;
gridComp.prototype.setRowUnFocus = setRowUnFocus;
gridComp.prototype.resetNumCol = resetNumCol;


gridComp.prototype.renderTypeFun = renderTypeFun;
gridComp.prototype.renderTypeByColumn = renderTypeByColumn;
gridComp.prototype.renderTypeSumRow = renderTypeSumRow;


gridComp.prototype.setColumnVisibleByColumn = setColumnVisibleByColumn;
gridComp.prototype.setColumnVisibleByIndex = setColumnVisibleByIndex;
gridComp.prototype.setCoulmnWidthByField = setCoulmnWidthByField;
gridComp.prototype.setColumnWidth = setColumnWidth;
gridComp.prototype.setDataSource = setDataSource;
gridComp.prototype.setDataSourceFun1 = setDataSourceFun1;


gridComp.prototype.widthChangeFun = widthChangeFun;
gridComp.prototype.widthChangeGridFun = widthChangeGridFun;
gridComp.prototype.widthChangeGridFunFixed = widthChangeGridFunFixed;
gridComp.prototype.widthChangeGridFunOverWidthHidden = widthChangeGridFunOverWidthHidden;
gridComp.prototype.heightChangeFun = heightChangeFun;
gridComp.prototype.contentWidthChange = contentWidthChange;

var gridCompProto = gridComp.prototype;

/*
 * colmuenu
 */
 var oldInitGridCompColumn= gridCompProto.initGridCompColumn,
     oldInitEventFun= gridCompProto.initEventFun,
     oldInitGridEventFun= gridCompProto.initGridEventFun;

 import{
    re_initGridCompColumnColumnMenuFun,
 	colMenu_initGridCompColumn,
 	re_createColumnMenu,
 	colMenu_initEventFun,
 	colMenu_initGridEventFun
 } from './re_gridCompColMenu';

 gridCompProto.initGridCompColumnColumnMenuFun = re_initGridCompColumnColumnMenuFun;
 gridCompProto.initGridCompColumn = function(){
     // 执行原有方法
    oldInitGridCompColumn.apply(this,arguments);
    colMenu_initGridCompColumn.apply(this,arguments);

 };
 gridCompProto.createColumnMenu = re_createColumnMenu;
 gridCompProto.initEventFun = function(){
     // 执行原有方法
    oldInitEventFun.apply(this,arguments);
    colMenu_initEventFun.apply(this,arguments);
 };
 gridCompProto.initGridEventFun = function(){
     // 执行原有方法
    oldInitGridEventFun.apply(this,arguments);
    colMenu_initGridEventFun.apply(this,arguments);
 };

 if(typeof gridCompProto.saveGridCompColumnArrToLocal == 'undefined'){
 	gridCompProto.saveGridCompColumnArrToLocal = function(){
 	};
 }
 if(typeof gridCompProto.clearLocalData == 'undefined'){
 	gridCompProto.clearLocalData = function(){
 	};
 }


/*
 * grag
 */
var oldInitEventFun_grag= gridCompProto.initEventFun;
var oldInitGridEventFun_grag= gridCompProto.initGridEventFun;
 import{
     re_createHeaderDrag,
     drag_initEventFun,
     drag_initGridEventFun,
     dragStart,
     dragFun,
     dragEnd,
     headerThDrag,
     re_resetThVariableDrag
 } from './re_gridCompDrag';

 gridCompProto.createHeaderDrag = re_createHeaderDrag;
 gridCompProto.initEventFun = function(){
     // 执行原有方法
    oldInitEventFun_grag.apply(this,arguments);
    drag_initEventFun.apply(this,arguments);
 };
 gridCompProto.initGridEventFun = function(){
     // 执行原有方法
    oldInitGridEventFun_grag.apply(this,arguments);
    drag_initGridEventFun.apply(this,arguments);
 };
 gridCompProto.dragStart = dragStart;
 gridCompProto.dragFun = dragFun;
 gridCompProto.dragEnd = dragEnd;
 if(typeof gridCompProto.saveGridCompColumnArrToLocal == 'undefined'){
     gridCompProto.saveGridCompColumnArrToLocal = function(){
     };
 }
 gridCompProto.headerThDrag = headerThDrag;
 gridCompProto.resetThVariableDrag = re_resetThVariableDrag;


 /*
  * edit
  */
   var oldInitEventFun_edit= gridCompProto.initEventFun;
 import{
     re_hideEditMenu,
     re_clickFunEdit,
     editRowFun,
     editRowIndexFun,
     editRow,
     re_editClose,
     editCell,
     nextEditShow,
     editValueChange,
     re_updateEditRowIndex,
     re_updateValueAtEdit,
     setEditType,
     setEditable,
     edit_initEventFun,
     setGridEditType,
     setGridEditTypeAndEditRow
 } from './re_gridCompEdit';

gridCompProto.hideEditMenu = re_hideEditMenu;
gridCompProto.clickFunEdit = re_clickFunEdit;
gridCompProto.editRowFun = editRowFun;
gridCompProto.editRowIndexFun = editRowIndexFun;
gridCompProto.editRow = editRow;
gridCompProto.editClose = re_editClose;
gridCompProto.editCell = editCell;
gridCompProto.nextEditShow = nextEditShow;
gridCompProto.editValueChange = editValueChange;
if(typeof gridCompProto.formEditCell == 'undefined'){
	gridCompProto.formEditCell = function(){
	};
};
gridCompProto.updateEditRowIndex = re_updateEditRowIndex;
gridCompProto.updateValueAtEdit = re_updateValueAtEdit;
gridCompProto.setEditType = setEditType;
gridCompProto.setEditable = setEditable;
gridCompProto.initEventFun = function(){
    // 执行原有方法
   oldInitEventFun_edit.apply(this,arguments);
   edit_initEventFun.apply(this,arguments);
};
gridCompProto.setGridEditType = setGridEditType;
gridCompProto.setGridEditTypeAndEditRow = setGridEditTypeAndEditRow;


/*
 * editForm
 */
var oldInitDefault= gridCompProto.initDefault,
    oldSetRequired= gridCompProto.setRequired;
import{
    editForm_initDefault,
    editForm_setRequired,
    re_editorRowChangeFun,
    formEditCell
} from './re_gridCompEditForm';

gridCompProto.initDefault = function(){
    // 执行原有方法
   oldInitDefault.apply(this,arguments);
   editForm_initDefault.apply(this,arguments);
};
gridCompProto.setRequired = function(){
    // 执行原有方法
   oldSetRequired.apply(this,arguments);
   editForm_setRequired.apply(this,arguments);
};
gridCompProto.editorRowChangeFun = re_editorRowChangeFun;
gridCompProto.formEditCell = formEditCell;


/*
 * fixed
 */
var oldColumnsVisibleFun= gridCompProto.columnsVisibleFun;
import{
    re_initGridCompFixedColumn,
    fixed_columnsVisibleFun,
    re_createHeaderTableFixed,
    re_createContentTableFixed,
    re_createContentOneRowFixed,
    re_widthChangeGridFunFixed
} from './re_gridCompFixed';

gridCompProto.initGridCompFixedColumn = re_initGridCompFixedColumn;
gridCompProto.columnsVisibleFun = function(){
    // 执行原有方法
   oldColumnsVisibleFun.apply(this,arguments);
   fixed_columnsVisibleFun.apply(this,arguments);
};
gridCompProto.createHeaderTableFixed = re_createHeaderTableFixed;
gridCompProto.createContentTableFixed = re_createContentTableFixed;
gridCompProto.createContentOneRowFixed = re_createContentOneRowFixed;
gridCompProto.widthChangeGridFunFixed = re_widthChangeGridFunFixed;

/*
 * formShow
 */
import{
    createFromDivs,
    createFromContent,
    createFormContentRows,
    widthChangeFormFun
} from './re_gridCompFormShow'

gridCompProto.createFromDivs = createFromDivs;
gridCompProto.createFromContent = createFromContent;
gridCompProto.createFormContentRows = createFormContentRows;
gridCompProto.widthChangeFormFun = gridCompProto;

/*
 * headerLevel
 */
import{
    re_resetThVariableHeaderLevel,
    re_initGridCompColumnHeaderLevelFun,
    // initGridHiddenLevelColumn,
    getLevelTitleByField
} from './re_gridCompHeaderLevel'

gridCompProto.resetThVariableHeaderLevel = re_resetThVariableHeaderLevel;
gridCompProto.initGridCompColumnHeaderLevelFun = re_initGridCompColumnHeaderLevelFun;
// gridCompProto.initGridHiddenLevelColumn = initGridHiddenLevelColumn;
gridCompProto.getLevelTitleByField = getLevelTitleByField;

/*
 * localStorage
 */
import{
	re_initGridCompColumnLoacl,
	getLocalData,
	saveLocalData,
	clearLocalData,
	saveGridCompColumnArrToLocal,
	getGridCompColumnArrFromLocal
} from './re_gridCompLocalStorage';

gridCompProto.initGridCompColumnLoacl = re_initGridCompColumnLoacl;
gridCompProto.getLocalData = getLocalData;
gridCompProto.saveLocalData = saveLocalData;
gridCompProto.clearLocalData = clearLocalData;
gridCompProto.saveGridCompColumnArrToLocal = saveGridCompColumnArrToLocal;
gridCompProto.getGridCompColumnArrFromLocal = getGridCompColumnArrFromLocal;

/*
 * overWidthColumn
 */
import{
    re_initGridHiddenLevelColumn,
    re_widthChangeGridFunOverWidthHidden
} from './re_gridCompOverWidthHidden';

gridCompProto.initGridHiddenLevelColumn = re_initGridHiddenLevelColumn;
gridCompProto.widthChangeGridFunOverWidthHidden = re_widthChangeGridFunOverWidthHidden;


/*
 * sort
 */
var oldInitEventFun_sort = gridCompProto.initEventFun;
var oldInitGridEventFun_sort= gridCompProto.initGridEventFun;
import{
    sort_initEventFun,
    sort_initGridEventFun,
    canSortable,
    re_deleteOneRowTree,
    sortRowsByPrio,
    basicSortRows
} from './re_gridCompSort';

gridCompProto.initEventFun = function(){
    // 执行原有方法
   oldInitEventFun_sort.apply(this,arguments);
   sort_initEventFun.apply(this,arguments);
};
gridCompProto.initGridEventFun = function(){
    // 执行原有方法
    oldInitGridEventFun_sort.apply(this,arguments);
    sort_initGridEventFun.apply(this,arguments);
};
gridCompProto.canSortable = canSortable;
gridCompProto.deleteOneRowTree = re_deleteOneRowTree;
gridCompProto.sortRowsByPrio = sortRowsByPrio;

/*
 * sumRow
 */
import{
    re_createContentRowsSumRow,
    re_createContentSumRow,
    createSumRow,
    createSumRowForIE,
    re_repairSumRow,
    renderSumRow,
    re_renderTypeSumRow
} from './re_gridCompSumRow';

gridCompProto.createContentRowsSumRow = re_createContentRowsSumRow;
gridCompProto.createContentSumRow = re_createContentSumRow;
gridCompProto.createSumRow = createSumRow;
gridCompProto.createSumRowForIE = createSumRowForIE;
gridCompProto.repairSumRow = re_repairSumRow;
gridCompProto.renderSumRow = renderSumRow;
gridCompProto.renderTypeSumRow = re_renderTypeSumRow;


/*
 * swap
 */
var oldInitEventFun_swap= gridCompProto.initEventFun;
var oldInitGridEventFun_swap= gridCompProto.initGridEventFun;
import{
    swap_initEventFun,
    swap_initGridEventFun,
    swapColumnStart,
    swapColumnFun,
    swapColumnEnd
}from './re_gridCompSwap';

gridCompProto.initEventFun = function(){
    // 执行原有方法
   oldInitEventFun_swap.apply(this,arguments);
   swap_initEventFun.apply(this,arguments);
};
gridCompProto.initGridEventFun = function(){
    // 执行原有方法
    oldInitGridEventFun_swap.apply(this,arguments);
    swap_initGridEventFun.apply(this,arguments);
};
gridCompProto.swapColumnStart = swapColumnStart;
gridCompProto.swapColumnFun = swapColumnFun;
gridCompProto.swapColumnEnd = swapColumnEnd;



/*
 * tree
 */
import{
    re_initOptionsTree,
    re_clickFunTree,
    re_addOneRowTree,
    re_addOneRowTreeHasChildF,
    re_updateValueAtTree,
    getAllChildRow,
    getChildRowIndex,
    getAllChildRowIndex,
    getAllChildRowFun,
    getAllChildRowIndexFun,
    expandNode,
    expandNodeByIndex
} from './re_gridCompTree';

gridCompProto.initOptionsTree = re_initOptionsTree;
gridCompProto.clickFunTree = re_clickFunTree;
gridCompProto.addOneRowTree = re_addOneRowTree;
gridCompProto.addOneRowTreeHasChildF = re_addOneRowTreeHasChildF;
gridCompProto.updateValueAtTree = re_updateValueAtTree;
gridCompProto.getAllChildRow = getAllChildRow;
gridCompProto.getChildRowIndex = getChildRowIndex;
gridCompProto.getAllChildRowIndex = getAllChildRowIndex;
gridCompProto.getAllChildRowFun = getAllChildRowFun;
gridCompProto.getAllChildRowIndexFun = getAllChildRowIndexFun;
gridCompProto.expandNode = expandNode;
gridCompProto.expandNodeByIndex = expandNodeByIndex;



export{gridComp}



/** WEBPACK FOOTER **
 ** ./js/gridComp.js
 **/